import { Link } from "gatsby"
import React from "react"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { data } from "../constants/ServiceConstant"

const ServicesHome = () => {
  return (
    <section className="servies mt-3">
      <Container>
        <h3 className="mb-1 text-center mb-lg-1 text-lg-start">Our Services</h3>
        <h1 className="text-center text-lg-start mb-lg-5">
          PROVIDE BEST <span className="green">SERVICES</span>
        </h1>
        <Row>
          <Col md={12} xl={6} className="my-3 my-lg-0">
            <Card className="service-card" style={{ width: "33rem" }}>
              <Card.Img variant="top" src={data[0].image} />
              <Card.Body>
                <Card.Title>{data[0].title}</Card.Title>
                <Card.Text>{data[0].description}</Card.Text>
                <Link to="/services/personal-tax-returns">
                  <Button className="service-btn">Read More</Button>
                </Link>
              </Card.Body>
            </Card>
          </Col>
          <Col md={12} xl={6}>
            <Card className="service-card" style={{ width: "33rem" }}>
              <Card.Img variant="top" src={data[1].image} />
              <Card.Body>
                <Card.Title>{data[1].title}</Card.Title>
                <Card.Text>{data[1].description}</Card.Text>
                <Link to="/services/corporate-taxes">
                  <Button className="service-btn">Read More</Button>
                </Link>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Link
          to="/services"
          className="d-flex justify-content-center align-items-center my-4 text-decoration-none"
        >
          <button className="btn hero-btn btn-lg text-white">
            Explore More Services
          </button>
        </Link>
        {/* <div className="contact-end text-center phone-card my-5">
          <h3>NEED ANY HELP AT YOUR TAX SOLUTION?</h3>
          <p>
            JUST DAIL (647) 980-6298 <span className="green">OR</span> (647)
            340-3450
          </p>
        </div> */}
      </Container>
    </section>
  )
}

export default ServicesHome
